module.exports = __webpack_public_path__ + "static/media/talking.c790515c.svg";